<template>
  <form
    class="SignUpForm"
    @submit.prevent="submitRegister"
  >
    <div class="flex flex-col gap-2 rounded-2xl bg-white p-2 shadow-xl sm:flex-row sm:items-center sm:gap-0">
      <label
        :class="{ 'rounded-xl ring-1 ring-brand': v.email.$error }"
        class="min-w-0 flex-1 rounded-xl"
      >
        <span class="sr-only">{{ $t('forms.company_email') }}</span>
        <input
          v-model="formFields.email"
          :placeholder="$t('forms.enter_company_email')"
          type="email"
          class="w-full border-none bg-transparent px-3.5 py-2.5 font-sans text-sm text-ink outline-none placeholder:text-muted-faint"
          tabindex="0"
          data-testid="SignUpForm-Email"
          @input="v.email.$touch()"
        >
      </label>

      <span class="mx-1 hidden h-6 w-px self-center bg-line sm:block" />

      <label
        :class="{ 'rounded-xl ring-1 ring-brand': v.password.$error }"
        class="min-w-0 rounded-xl sm:w-[150px]"
      >
        <span class="sr-only">{{ $t('forms.create_password') }}</span>
        <input
          v-model="formFields.password"
          :placeholder="$t('forms.type_password')"
          type="password"
          class="w-full border-none bg-transparent px-3.5 py-2.5 font-sans text-sm text-ink outline-none placeholder:text-muted-faint"
          tabindex="0"
          data-testid="SignUpForm-Password"
          @input="v.password.$touch()"
        >
      </label>

      <button
        :disabled="isLoading"
        type="submit"
        class="shrink-0 cursor-pointer whitespace-nowrap rounded-full border-none bg-black px-6 py-2.5 text-sm font-bold text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
        data-testid="submit"
        @click="sendGAClickEvent(gaEvent)"
      >
        {{ submitLabel || $t('forms.register') }}
      </button>
    </div>

    <!-- Validation help floats below the pill so an error never distorts the bar.
         Both form instances sit on dark bands, so help renders in a light red. -->
    <div
      v-if="v.email.$error || v.password.$error"
      class="mt-2 flex flex-col gap-0.5 text-sm text-[#ff9ea0]"
    >
      <span v-if="v.email.$error">{{ fieldError(v.email, $t('forms.company_email')) }}</span>
      <span v-if="v.password.$error">{{ fieldError(v.password, $t('forms.create_password')) }}</span>
    </div>
  </form>
</template>

<script>
import fieldErrorMixin from '@/components/dashboard/settings/fieldErrorMixin'

/**
 * Merged "pill" register form (email + password + Register) matching the redesign.
 * S17: de-Bulma'd — the Bulma `form-field`/`.input`/`v-button` were replaced with the
 * house borderless cells inside the pill + `fieldErrorMixin` for validation messages
 * (floated below the bar). The prop/model/emit contract and every `data-testid` are
 * unchanged, so its consumers (FreeNewsroomLanding2's two forms) behave identically.
 */
export default {
  mixins: [fieldErrorMixin],

  model: {
    prop: 'formFields',
    event: 'input'
  },

  props: {
    gaEvent: { type: String, default: 'hypenews signup animated' },
    submitRegister: { type: Function, default: () => {} },
    formFields: { type: Object, required: true },

    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },

    v: {
      type: Object,
      required: true
    },

    isHorizontal: {
      type: Boolean,
      default: false
    },

    /** Submit button text; falls back to the generic "Register" when empty */
    submitLabel: {
      type: String,
      default: ''
    }
  },

  methods: {
    sendGAClickEvent (event) {
      this.$ma.trackEvent({
        category: 'button',
        action: 'click',
        label: event
      })
    }
  }
}
</script>
